import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import SeasonsPage from "./components/SeasonsPage";
import PlayerPage from "./components/PlayerPage";
import Header from "./components/Header";

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/seasons/:name" element={<SeasonsPage />} />
                <Route path="/player/:name/:season" element={<PlayerPage />} />
            </Routes>
        </Router>
    );
}

export default App;
